(function () {
  'use strict';

  if (window.PGHomeCollectionFixV18) return;
  window.PGHomeCollectionFixV18 = true;

  var LEGACY_COLLECTION_IDS = [
    'fecb0a36-2a11-41da-9e38-692975772f38',
    'bcd1b8b9-6a67-4eaa-bea0-b57131409e72',
    'ca1b4a4d-9581-49b6-9321-288416788286'
  ];

  function isHomepage() {
    var body = document.body;
    return Boolean(body && (
      body.classList.contains('index') ||
      body.classList.contains('template-index')
    ));
  }

  function closestSection(node) {
    return node && node.closest ? (node.closest('.shopify-section') || node) : node;
  }

  function removeOldShopByStyle() {
    var selectors = [
      '[id$="__pg_shop_by_style_tbWMgc"]',
      '#shopify-section-pg_shop_by_style_tbWMgc',
      '.pg-style-shop-pg_shop_by_style_tbWMgc'
    ];

    document.querySelectorAll(selectors.join(',')).forEach(function (node) {
      var section = closestSection(node);
      if (!section || section.querySelector('[data-pg-home-shelf]')) return;
      section.remove();
    });
  }

  function restoreApprovedShelf() {
    var shelf = document.querySelector('[data-pg-home-shelf]');
    if (!shelf) return;

    var host = shelf.closest('.pg-home-shelf-host') || shelf.parentElement;
    var section = closestSection(shelf);

    [host, section].forEach(function (node) {
      if (!node) return;
      node.style.setProperty('display', 'block', 'important');
      node.style.setProperty('visibility', 'visible', 'important');
      node.style.setProperty('opacity', '1', 'important');
      node.style.setProperty('height', 'auto', 'important');
      node.removeAttribute('hidden');
      node.setAttribute('data-pg-collection-presentation', 'approved-v18');
    });

    if (host) {
      host.querySelectorAll('.tab_collections').forEach(function (tabs) {
        tabs.style.setProperty('display', 'none', 'important');
        tabs.setAttribute('aria-hidden', 'true');
      });
    }
  }

  function hideLegacyFeaturedCollections() {
    LEGACY_COLLECTION_IDS.forEach(function (id) {
      document.querySelectorAll('[id$="__' + id + '"], #shopify-section-' + id).forEach(function (node) {
        var section = closestSection(node);
        if (!section || section.querySelector('[data-pg-home-shelf]')) return;
        section.style.setProperty('display', 'none', 'important');
        section.setAttribute('aria-hidden', 'true');
      });
    });
  }

  function restoreHeading() {
    document.querySelectorAll('.pg-njp__heading').forEach(function (heading) {
      heading.style.setProperty('font-family', '"Playfair Display", Georgia, serif', 'important');
      heading.style.setProperty('font-style', 'italic', 'important');
      heading.style.setProperty('font-weight', '700', 'important');
      heading.style.setProperty('letter-spacing', '0', 'important');
    });
  }

  function apply() {
    if (!isHomepage()) return;
    removeOldShopByStyle();
    restoreApprovedShelf();
    hideLegacyFeaturedCollections();
    restoreHeading();
  }

  function boot() {
    apply();
    [80, 250, 650, 1300, 2600, 4800].forEach(function (delay) {
      window.setTimeout(apply, delay);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function () {
    window.setTimeout(apply, 0);
  });
})();
